import { all } from 'redux-saga/effects'
import { programmeRootSaga } from './programme'
import { studentCourseSessionRootSaga } from './studentCourseSession'
import { moduleRootSaga } from './module'
import { engagementRootSaga } from './engagement'

export function* rootSaga() {
	yield all([programmeRootSaga(), studentCourseSessionRootSaga(), moduleRootSaga(), engagementRootSaga()])
}
